<template>
	<div id="queryVoucher" class="public-content">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">
			<el-form label-width="90px" inline label-position="left">
				<el-form-item label="查询凭证">
					<div @click.stop="boxHide = !boxHide" class='s_container'>
						<el-input  size="small" readonly v-model='yearPeriodsText' placeholder="请选择筛选条件">
							<el-button slot="append" icon="el-icon-search" class='el_primary' size='small'
							>筛选</el-button>
						</el-input>
					</div>
					<!-- 悬浮搜索框 -->
					<!-- @mouseleave="boxHide = false" -->
					<div class="searchBox" @click.stop='returnFalse'>
						<transition name="el-zoom-in-top">
							<search-box v-show="boxHide"
										ref='searchBoxDom'
										@sendFalseMessage='getFalseMessage'
										@formMessage='formMessage'
										@VoucherWord = 'getVoucherWord'
										@defaultDate = 'defaultDate'
							></search-box>
						</transition>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button type="text" v-for='i in buttonList' :key='i.id' @click='handleButtonOperation(i.name)'>{{i.name}}</el-button>
				</el-form-item>

				<el-form-item class="right-position">
					<span v-for="(item,index) in buttonList2" :key="index">
						<el-button size="small" v-if="item.permission == 'chronological:account:export' " @click="getShiXuZhang" style='margin: 0 10px;'>{{item.name}}</el-button>

							<el-button size="small" v-if="item.permission == 'ac:voucher:print' " @click='printFunction'>
								打印
							</el-button>
						<el-button size="small" v-if="item.permission == 'ac:voucher:import' " @click="getimportFiles" style='margin: 0 10px;'>导入</el-button>
						<el-button size="small" v-if="item.permission == 'ac:voucher:export' " style='margin-right: 10px;' @click='inportOutFunction'>导出</el-button>
						<el-button size="small" v-if="item.permission == 'ac:voucher:addVoucher' " class='minButton' @click="goPath('/addVoucher')">新增凭证</el-button>
					</span>
				</el-form-item>
			</el-form>
		</div>
		<!-- 公共table 样式 -->
		<div class="queryVoucher-tableList">
      <public-table  :table="tableData" 	@onHandlePaginationChange="handlePaginationChange" ref='DetailTable'>
		<template slot="billNum" slot-scope="props">
			<el-button type="text" @click="openPreview(props.scope.row)">{{props.scope.row.billNum + props.scope.row.numAttach}}张</el-button>
		</template>
      	<template slot-scope="props" slot="auditingUserName">
      		<span v-show="props.scope.row.auditStatus != 0"  v-text='props.scope.row.auditingUserName'></span>
      	</template>
      	<template slot-scope="props" slot="certificateWordAndNumber">
      		<!-- <a href="javascript:;" v-text="props.scope.row.certificateWordAndNumber" @click="handleModify(props.scope.row)"></a> -->

      		<el-button type='text'
      					@click="handleModify(props.scope.row)"
      					>
      			{{props.scope.row.certificateWordAndNumber}}
      		</el-button>
      	</template>
      	<template slot-scope="props" slot="operation">
			<!-- <div class="list_btns"> -->
				<el-button type='text' v-for='item in props.scope.row.buttons' :key='item.id'  v-show="item.permission != 'ac:voucher:detail' ? true : false"
							:class='item.name=="删除"?"red":""'
							@click='handleClickOperation(item.name , props.scope.row)'
							>
					{{item.name}}
				</el-button>
			<!-- </div> -->
      	</template>
      	<template slot-scope="props" slot="allSelect">
      		<el-checkbox @change='handleSelectChange' v-model='props.scope.row.allSelect' v-if='props.scope.row.rows'></el-checkbox>
      	</template>
      	<template slot-scope='props' slot='mark'>
      		<!-- <flag-mark></flag-mark> -->
      		<el-popover
      		    placement="bottom"
      		    width="320"
      		    popper-class='queryVoucher_mark'
      		    v-model='props.scope.row.isPopoverShow'
      		    trigger="manual">
      		    <div >
      		    	<el-radio v-model="props.scope.row.signId_c" v-for='i in markList' :label="i.id" :key='i.id'
      		    	@change='handleRadioChange(props.scope.row,$event)'>
      		    		<i class='iconfont iconlastTime' :style='{fontSize: "20px",color: i.color}'></i>
      		    	</el-radio>
      		    </div>
      		    <div class='mark_item'>
      		    	<el-input type='textarea'  maxlength='80' show-word-limit placeholder="请输入标记原因"
      		    		v-model='props.scope.row.signReason_c'
      		    		resize='none'
      		    		clearable
      		    		@focus='handleInputFocus'
      		    		:autosize='{minRows: 3, maxRows: 6 }'
      		    	></el-input>

      		    </div>
      		    <div style='text-align: center;' class='mark_item'>
      		    	<el-button size='small' @click='handleHideChange(props.scope.row)'>取消</el-button>
      		    	<el-button size='small' @click='saveMark(props.scope.row)' type='primary'>确认</el-button>
      		    </div>
      		     <el-tooltip class="item" effect="light"  placement="bottom" slot="reference"
      		     	:visible-arrow='false'
      		     	v-if='props.scope.row.signReason'
      		     	transition='null'
      		     >
      		     	<span slot='content'>{{(props.scope.row.signReason?props.scope.row.signReason:"无")}}</span>
      		      <i  class='iconfont iconlastTime' :style='retunMarkStyle(props.scope.row)'
      		     @click.stop='clickPopoverShow(props.scope.row)'></i>
      		    </el-tooltip>
      		   	 <i  class='iconfont iconlastTime' :style='retunMarkStyle(props.scope.row)'
      		   	 v-if='!props.scope.row.signReason'
      		   	 slot="reference"
      		     @click.stop='clickPopoverShow(props.scope.row)'></i>
      		</el-popover>
      	</template>
      </public-table>
    </div>



		<!-- 导入凭证 -->
		<el-dialog
			title="导入凭证" :visible.sync="importFiles" width="400px" :close-on-click-modal="false" class='DR_dialog'>
			<div v-loading='isImportFilesLoading' element-loading-text="正在上传文件...">
				<div class="fliesUplaod"  >
					<h4 class='color333'>下载模板</h4>
					<el-button type="text" class='handleDownload' @click='handleDownload_MB'>点击下载模板</el-button>
					<h4 class='color333'>导入表单</h4>
					<div class="uploads">
						<el-upload
						  drag
						  action="https://jsonplaceholder.typicode.com/posts/"
						  :show-file-list='true'
						  :auto-upload="false"
						  :on-change="OnChange"
						  :on-remove="OnRemove"
						  :before-remove="beforeRemove"
						  :limit='handleLimit'
						  ref='upload'
						  >
						  <i class="el-icon-upload"></i>
						  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						  <div class="el-upload__tip" slot="tip">只能上传.xls/.xlsx文件，且不超过5M</div>
						</el-upload>
					</div>
					<el-checkbox v-model='isArrangement'>对凭证重新编号</el-checkbox>
					<div style="padding-top: 10px;">
						<el-checkbox v-model='isUse' style='margin: 0'>对科目重新编号</el-checkbox><span class="f12 color999">（勾选后，科目名称一致的科目编号将以系统为准，否则将需要严格和系统科目匹配）</span>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" class='minButton' @click="handleUploadAdd">确定导入</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 整理弹框 -->
    <Arrange
      :visible = "ZL_voucherShow"
      @close = "ZL_voucherShow = false"
      :loading="ZLPZ_loading"
      :VoucherWord = "VoucherWord"
      @confirm = "handleConfirm"
    />
		<!-- 修改凭证  -->
		<edit-voucher :visible="XG_voucherShow" :row="rows" :openButton_s='openButton_s'
			@on-close-dialog="cancel($event,'edit')" @on-success-submit="successEdit"
			@successSaveMark='successSaveMark'
			v-if="XG_voucherShow"></edit-voucher>

		<!-- 插入凭证凭证  -->
		<el-dialog title="插入凭证" :visible.sync="CR_voucherShow" width="1250px" :close-on-click-modal="false" @close="cancel">
			<div class="Voucher_OverFLow">
				<voucher-content :insert="insert"  @on-submit-success="successAjax1($event,'CR_voucherShow')" v-if="CR_voucherShow"></voucher-content>
			</div>
		</el-dialog>

		<!-- 打印弹框 -->
		<!-- <el-dialog title="打印设置" :visible.sync="printDialogShow" width="480px" :close-on-click-modal="false" class='printDialog_s'>
			<div class='print_container'>
				<div>
					<span class='printTitle'>打印范围：</span>
					 <el-radio v-model="printFormData.exportScope" label="2">当前勾选</el-radio>
                     <el-radio v-model="printFormData.exportScope" label="1">当前期间全部</el-radio>
				</div>
				<div style='margin-top: 20px;'>
					<span class='printTitle'>打印方向：</span>
					 <el-radio v-model="printFormData.direction" label="1">横向</el-radio>
                     <el-radio v-model="printFormData.direction" label="2">纵向</el-radio>
				</div>
				<div style='margin-top: 20px;text-align: right;'>
					<el-button size="small" class='minButton' @click="handlePrint">打印</el-button>
				</div>
			</div>
		</el-dialog> -->

    <el-dialog title="打印设置" :visible.sync="printDialogShow" width="600px" center custom-class="printDialog" @closed="printFormData = $options.data().printFormData" @open="getPrintSetting" >
      <!-- 打印模板 -->
      <div class="print_area">
        <div class="print_area_title">打印模板</div>
        <div class="print_area_template">
          <div class="print_area_template_A4">
            <div class="print_area_template_A4_title">A4</div>
            <div class="print_area_template_A4_contents">
              <div class="print_area_template_A4_content" :class="printFormData.template === 1 ? 'active':''" @click="printFormData.template = 1">
                <div class="print_template_item item_1">
                  记账凭证01
                </div>
                <div class="print_template_footer">
                  每页1张凭证
                </div>
              </div>
              <div class="print_area_template_A4_content" :class="printFormData.template === 2 ? 'active':''" @click="printFormData.template = 2">
                <div class="print_template_item item_2">
                  记账凭证01
                </div>
                <div class="print_template_item item_2">
                  记账凭证02
                </div>
                <div class="print_template_footer">
                  每页2张凭证
                </div>
              </div>
              <div class="print_area_template_A4_content" :class="printFormData.template === 3 ? 'active':''" @click="printFormData.template = 3">
                <div class="print_template_item item_3">
                  记账凭证01
                </div>
                <div class="print_template_item item_3">
                  记账凭证02
                </div>
                <div class="print_template_item item_3">
                  记账凭证03
                </div>
                <div class="print_template_footer">
                  每页3张凭证
                </div>
              </div>
            </div>
          </div>
          <div class="print_area_template_A5">
            <div class="print_area_template_A5_title">A5</div>
            <div class="print_area_template_A5_contents">
              <div class="print_area_template_A5_content" :class="printFormData.template === 4 ? 'active':''" @click="printFormData.template = 4">
                <div class="print_template_item item_1">
                  记账凭证01
                </div>
                <div class="print_template_footer">
                  每页1张凭证
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 打印范围 -->
      <div class="print_area">
        <div class="print_area_title">打印范围</div>
        <div class="print_area_scope">
          <el-radio-group v-model="printFormData.exportScope">
            <el-radio label="2">当前勾选</el-radio>
            <el-radio label="1">当前期间全部</el-radio>
          </el-radio-group>
        </div>
      </div>
	  <div class="print_area">
        <div class="print_area_title">打印方向</div>
        <div class="print_area_scope">
          <el-radio-group v-model="printFormData.rotate" >
			<el-radio :label="1">纵向</el-radio>
            <el-radio :label="2">横向</el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- 打印内容 -->
      <div class="print_area">
        <div class="print_area_title">打印内容</div>
        <div class="print_area_quality">
          <div class="print_area_left">
            <el-checkbox v-model="printFormData.unitPrice">数量单价</el-checkbox>
            <el-checkbox v-model="printFormData.currency">外币</el-checkbox>
            <div style="position:relative">
              <el-checkbox v-model="printFormData.cover">封面</el-checkbox>
              <img src="../../../static/img/default_img.png" alt="" title="查看凭证封面" class="absolute_img" @click="showCover = true">
            </div>
            <el-checkbox v-model="printFormData.relatedBanks">回单</el-checkbox>
          </div>
          <div class="print_area_right">
            <div class="print_area_right_item">
              <el-checkbox v-model="printFormData.manager">主管</el-checkbox>
              <el-input v-model.trim="printFormData.managerName" style="width:304px" size="mini" placeholder="请输入名字" :disabled="!printFormData.manager" :class="{'error_input': managerError}"></el-input>
              <span class="error_msg" v-show="managerError">请输入主管名字</span>
            </div>
            <div class="print_area_right_item">
              <el-checkbox v-model="printFormData.audit">审核</el-checkbox>
              <el-input v-model.trim="printFormData.auditName" style="width:304px" size="mini" placeholder="请输入名字" :disabled="!printFormData.audit" :class="{'error_input':auditError}"></el-input>
              <span class="error_msg" v-show="auditError">请输入审核名字</span>
            </div>
            <div class="print_area_right_item">
              <el-checkbox v-model="printFormData.cashier">出纳</el-checkbox>
              <el-input v-model.trim="printFormData.cashierName" style="width:304px" size="mini" placeholder="请输入名字" :disabled="!printFormData.cashier" :class="{'error_input':cashierError}"></el-input>
              <span class="error_msg" v-show="cashierError">请输入出纳名字</span>
            </div>
            <div class="print_area_right_item">
              <el-checkbox v-model="printFormData.tabulation">制单</el-checkbox>
              <el-input v-model.trim="printFormData.tabulationName" style="width:304px" size="mini" placeholder="请输入名字" :disabled="!printFormData.tabulation" :class="{'error_input':tabulationError}"></el-input>
              <span class="error_msg" v-show="tabulationError">请输入制单名字</span>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer print_area_btns">
        <el-button @click="printDialogShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="printConfirm" size="small">打印凭证</el-button>
      </span>
    </el-dialog>

		<!-- 导出弹框 -->

		<el-dialog title="导出设置" :visible.sync="exportDialogShow" width="480px" :close-on-click-modal="false" class='printDialog_s'>
			<div class='print_container'>
				<div>
					<span class='printTitle'>导出范围：</span>
					<div style='margin-top: 20px;margin-left: 10px'>
						<el-radio v-model="exportFormData.exportScope" label="2">当前勾选</el-radio>
                        <el-radio v-model="exportFormData.exportScope" label="1">当前期间全部</el-radio>
					</div>

				</div>
				<div style='margin-top: 20px;'>
					<span class='printTitle'>导出类型：</span>
					<div style='margin-top: 20px;margin-left: 10px'>
						<el-radio v-model="exportFormData.exportType" label="1">导出通用文件</el-radio>
	                     <el-radio v-model="exportFormData.exportType" label="2">按"导入模板"导出</el-radio>
	                     <el-radio v-model="exportFormData.exportType" label="3">导出凭证PDF</el-radio>
					</div>

				</div>
				<div style='margin-top: 20px;text-align: right;'>
					<el-button size="small" class='minButton'  @click="handleDownload" >导出</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 查看凭证凭证  -->
		<el-dialog title="查看凭证" :visible.sync="CK_voucherShow" width="1250px" :close-on-click-modal="false" @close="cancel">
			<div class="Voucher_OverFLow" v-loading="CK_Voucer_loading">
				<div class="disableModal" v-show="CK_voucherShow"></div>
				<voucher-content :voucherData="Voucher_Chief_Data" :watch="insert"
					@on-submit-success="successAjax1($event,'CK_voucherShow')" v-if="CK_voucherShow"
				></voucher-content>
			</div>
		</el-dialog>

    <!-- 查看封面 -->
    <el-dialog :visible.sync="showCover" width="900px" :close-on-click-modal="true" @close="showCover = false" custom-class="coverDialog">
      <img src="../../../static/img/cover.jpg" alt="">
		</el-dialog>
	<!-- 预览图片-->
	<previewPicture ref="previewPicture" :images="images"/>
	</div>
</template>

<script>
import previewPicture from "@/components/previewPicture";
import searchBox from "@/components/dialog/searchBox"
import publicTable from '@/components/publicTable'
import {currencys} from '@/assets/utils/currencyFormat'
import accountingPeriod from '@/components/dialog/accountingPeriod'
import voucherContent from '@/components/table/voucherTableContent'
import editVoucher from '@/components/table/editVoucher'
import Arrange from "./components/arrange.vue"
import { changeVoucherSequence, findVoucherChiefPrintTemplate } from "@/api"
import { imgShow } from "@/assets/js/apiConfig.js";
export default {
	components:{
		searchBox,
		publicTable,
		accountingPeriod,
		voucherContent,
		editVoucher,
		previewPicture,
    Arrange
	},
	data(){
		return {
			imgShow,
			images:[],
			openButton_s: false,  // 是否打开翻页
			markList:[
				{id:'1',color:'#999'},
				{id:'2',color:'green'},
				{id:'3',color:'#f5a623'},
				{id:'4',color:'#e5691f'},
				{id:'5',color:'#d0021b'},
			],
			printFormData:{  // 打印参数
				rotate:1,
        template:1, // 打印模板 1 2 3 4
				exportScope:'2',  // 1当前期间全部 2 当前勾选
				// direction:"1", // transverse横向，空为纵向
        unitPrice:false, // 数量单价
        currency:false, // 外币
        cover:false, // 封面
        relatedBanks:false, // 回单
        manager:false, // 主管
        managerName:'', // 主管名字
        audit:false, // 审核
        auditName:"", // 审核名字
        cashier: false, // 出纳
        cashierName:"", // 出纳名字
        tabulation:false, // 制单
        tabulationName:"", // 制单名字
			},
      showCover:false, // 凭证封面弹窗
			exportFormData:{  // 导出参数.
				exportType:"1",  // 导出类型 1  导出通用 2 按导入的模板 3 导出pdf
				exportScope:"1"
			},
			printDialogShow: false,  // 打印显示
			exportDialogShow:false,  // 导出显示
			isFirstActive: false,
			handleLimit: 1,        // 上传文件数
			isImportFilesLoading: false,
			params : new FormData(),
			isArrangement: false,   // 是否对凭证重新编号
			isUse: false,           // 是否科目排序
			fileList:[],       // 上传文件列表
			rowIndex: '',           // 当前鼠标移入行
			hoverOrderArr: [],    // 合并class  hover效果
			OrderIndexArr: [],      // 合并数据集合
			yearPeriodsText: '',  // 会计期间展示文字
			buttonList: [],
			buttonList1: [],
			buttonList2: [],
			title:'查找凭证',
			ZLPZ_loading: false,            // 整理凭证loading
			boxHide:false,
			superStyles: '270px',
			ZL_voucherShow: false,             // 整理凭证

			XG_voucherShow: false, //修改凭证modal
			rows:{}, //修改凭证列表数据

			CR_voucherShow:false,

			CK_voucherShow:false,
			CK_Voucer_loading:false,

			Voucher_Chief_Data:{},
			VoucherWord: [],
			form:{
				currentPage: 1,					// 当前页码
				maxResult: 10,				// 当前分页数
				sortDateType: '',     // 日期排序
				sortNumberType: 'asc'       // 凭证排序
			},
			ZLPZ_form: {
				yearPeriods: '',
				fkVoucherWordId: '',
				mode:'1'

			},
			importFiles: false,
			importFilesResult: false,        // 导入结果显示
			ids: '',
			idsArr:[],      // 不重复数组
			tableData: {
        Maxheight:"500px",
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,		// 是否显示加载动画
				hasSelect: true,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: true,	// 是否显示分页
				key: 0,						// 渲染Table
				config: [{
					label: '日期',
					value: 'time',
					width: 80,
					show: 'normal',

				},{
					label: '凭证字号',
					value: 'certificateWordAndNumber',
					width: 80,
					show: 'template'
				},{
					label: '附件数量',
					value: 'billNum',
					width: 80,
					show: 'template'
				}
				,{
					label: '摘要',
					value: 'summary',
					width: 280,
					show: 'normal'
				},{
					label: '科目',
					value: 'subNameCodeAndAuxiliaryName',
          width: 200,
					show: 'normal',
				},{
					label: '借方金额',
					value: 'debit_money',
					width: 130,
					show: 'normal'
				},{
					label: '贷方金额',
					value: 'creditor_money',
					width: 130,
					show: 'normal'
				},{
					label: '制单人',
					value: 'createbyName',
					width: 100,
					show: 'normal'
				},{
					label: '审核人',
					value: 'auditingUserName',
					width: 150,
					show: 'template'
				},
				{
					label: '操作',
					value: 'operation',
					width: 150,
					show: 'template',
					showOverflowTooltip:false,
				},
				{
					label: '标记',
					value: 'mark',
					width: 60,
					show: 'template'
				},],
				operation: {
					label: '操作',
					value: 'operation',
					data: []
				},
				data: [],

				page: {
					pageNo: 1,
					pageSize: 10,
					count: 0
				},
				center: {
					textAlign: 'center',
					padding: '6px 0',
				},
				arraySpanMethod: this.arraySpanMethod,			// 自定义合并行
				toggleRowSelection: this.toggleRowSelection,		// 自定义全选方法
				tableRowClassName: this.tableRowClassName,		// 自定义hover效果
				cellMouseEnter: this.cellMouseEnter,		// 自定义鼠标移入
				cellMouseLeave: this.cellMouseLeave,		// 自定义鼠标移出
				handleSelect: this.handleSelect,		// 自定义鼠标移出
				renderHeader: this.renderHeader,            // 自定义表头方法
			},
			insert:1,
			iconName: 'ascendingorder',

			clickChange: true,         // 点击切换
			imgStyle: {
				display: 'none',
				width: '12px',
				height: '12px',
				marginLeft: '5px',
				marginBottom: '5px',
				position: 'absolute',
				top:'7px',
			},
			imgStyle1: {
				display: 'inline-block',
				width: '12px',
				height: '12px',
				marginLeft: '5px',
				marginBottom: '5px',
				position: 'absolute',
				top:'7px',
			},
			firstgetin: true,        // 请求一次
			conutTimes: 1,        // 重复名
			nowRowClickData:{},  // 当前点击标记行
		}
	},

	created(){
		let arrs = ['ac:voucher:audit','ac:voucher:auditback','ac:voucher:arrangement','ac:voucher:batchdelete'];
		let arrs2 = ['ac:voucher:print','ac:voucher:import','ac:voucher:export','ac:voucher:addVoucher','chronological:account:export'];
		this.getButton(arrs,'buttonList');
		this.getButton(arrs2,'buttonList2');
	},
	mounted(){
    this.getTableHeight();
	},
	computed: {
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		},
    managerError(){
      return this.printFormData.manager && !this.printFormData.managerName
    },
    auditError(){
      return this.printFormData.audit && !this.printFormData.auditName
    },
    cashierError(){
      return this.printFormData.cashier && !this.printFormData.cashierName
    },
    tabulationError(){
      return this.printFormData.tabulation && !this.printFormData.tabulationName
    }
	},
	activated() {
		// if(this.getClickCache&&this.isFirstActive) {
		// 	this.$refs.searchBoxDom.Reset();
		// 	//this.getTableData(this.form);
		// }
		// this.isFirstActive = true;
	},
	methods:{
	openPreview(row){
		if(row.numAttach){
			this.images = row.attachmentInfoList.map(x=>`${this.imgShow}${x.filePath}`)
			this.$refs.previewPicture.show()
		}else {
			return
		}
		console.log(row)
		// this.images
	},
    // 动态获取表格高度
    getTableHeight() {
      let dom = document.getElementById("queryVoucher");
      if(!dom)  return;
      let height = dom.clientHeight - 86 - 72;
      this.tableData.Maxheight = height + "px";
    },
		getShiXuZhang() {
			const params = {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
				startYearPeriods:this.form.startYearPeriods,
				endYearPeriods: this.form.endYearPeriods
			}
			const router =this.$router.resolve({
				path: '/export/chronological',
				query: params
			})
			location.href = this.$rootUrl + router.href
			// window.open(this.$rootUrl + router.href, '_blank');
		},
		// 得到焦点全选文字
		handleInputFocus(e){
			e.target.select();
		},
		// 操作标记点击
		clickPopoverShow(row) {
			const _ = this;
			this.nowRowClickData = row;
			row.isPopoverShow = !row.isPopoverShow;
		},

		// 子组件标记
		successSaveMark(data) {
			if(data) {
				this.getTableData(this.form)
			}
		},
		handleRadioChange(row,val) {
			row.signReason_c = row.signReason;
		},
		// 隐藏时同步理由和选项
		handleHideChange(row) {
			row.isPopoverShow = false;
			setTimeout(()=>{
				row.signReason_c = row.signReason;
				row.signId_c = row.signId;
			},300)

		},
		// 返回标记颜色
		retunMarkStyle(row) {
			let params = {
				fontSize:"20px",
				cursor:"pointer",
				color:"",
			}

			switch(row.signId) {
				case '1':
					params.color='#999';
					break;
				case '2':
					params.color='green';
					break;
				case '3':
					params.color='#f5a623';
					break;
				case '4':
					params.color='#e5691f';
					break;
				case '5':
					params.color='#d0021b';
					break;
			}
			return params
		},
		// 保存标记
		saveMark(row) {
			try {
				row.isPopoverShow = false;
				this.$http.post('voucherChief/setUpSign' , {signId:Number(row.signId_c),signReason:row.signReason_c,id:row.id}).then(res=>{
					if(res && res.data.code == 1) {
						this.$message.success(res.data.msg)
						this.getTableData(this.form)
					}
				})
			}catch(e){
			}
		},
				// 导入文件
		getimportFiles(){

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.nowRowClickData.isPopoverShow = false;
			this.importFiles = !this.importFiles;
		},
		// 打印
		printFunction() {
			this.printDialogShow=true;
			this.nowRowClickData.isPopoverShow = false;
		},
		// 导出
		inportOutFunction() {
			this.exportDialogShow=true;
			this.nowRowClickData.isPopoverShow = false;
		},
		// 自定义表头
		renderHeader(h,{column}) {
			if(column.property == "time") {
				return h("div",{
					class: 'click_container',
					on:{
						click: ()=>{
							this.$set(this.imgStyle1 , 'display' , 'none');
							this.$set(this.imgStyle , 'display' , 'inline-block');
							if(this.clickChange) {
								this.iconName = 'descendingorder'
								this.clickChange=!this.clickChange;
								this.$set(this.form,'sortDateType' , 'desc');
								this.$set(this.form,'sortNumberType' , '');
								this.getTableData(this.form);
							}else {
								this.iconName = 'ascendingorder'
								this.clickChange=!this.clickChange;
								this.$set(this.form,'sortDateType' , 'asc');
								this.$set(this.form,'sortNumberType' , '');
								this.getTableData(this.form);
							}
						}
					}
				}, [
			        h("span", ['日期']),
			        h("img", {
							attrs: {
			                	'src': "/static/icon/"+`${this.iconName}`+".svg"
							},
							style: this.imgStyle,

			            })
			    ])

			}else if(column.property == "certificateWordAndNumber"){
				return h("div",{
					class: 'click_container',
					on:{
						click: ()=>{
							this.$set(this.imgStyle1 , 'display' , 'inline-block');
							this.$set(this.imgStyle , 'display' , 'none');
							if(this.clickChange) {
								this.iconName = 'descendingorder'
								this.clickChange=!this.clickChange;
								this.$set(this.form,'sortNumberType' , 'desc');
								this.$set(this.form,'sortDateType' , '');
								this.getTableData(this.form);
							}else {
								this.iconName = 'ascendingorder'
								this.clickChange=!this.clickChange;
								this.$set(this.form,'sortNumberType' , 'asc');
								this.$set(this.form,'sortDateType' , '');
								this.getTableData(this.form);
							}
						}
					}
				}, [
			        h("span", ['凭证字号']),
			        h("img", {
							attrs: {
			                	'src': "/static/icon/"+`${this.iconName}`+".svg"
							},
							style: this.imgStyle1,
			            })
			    ])
			}else {
				return column.label
			}
		},

		// 下载模板
		handleDownload_MB() {

				let cid=sessionStorage.getItem('cid');

			  	let token=sessionStorage.getItem('token');

 				window.location.href = this.$rootUrl+'voucherChief/download?cid='+cid+'&token='+token;
 			},
		// 移出提示
		 beforeRemove(file, fileList) {
       		 return this.$confirm(`确定移除 ${ file.name }？`);
	      },
	      // 传入文件监听
	      OnChange(file,fileList){

	        this.fileList=fileList

	      },
	      // 移出操作
	      OnRemove(file,fileList){
	        this.fileList=fileList
	      },
		// 确认导入
		handleUploadAdd() {
			this.params = new FormData();
			// 导入验证
			if(this.fileList.length>1) {
				return this.$message.warning('只能从列表选择一个上传哟!')
			}
			if(!this.fileList.length) {
				return this.$message.warning('请选择上传文件!')
			}
			let fileOne = this.fileList[0];
			let testmsg=fileOne.name.substring(fileOne.name.lastIndexOf('.')+1)
			const extension = testmsg === 'xls'
			const extension2 = testmsg === 'xlsx'
			const isLt5M = fileOne.size / 1024 / 1024 < 5
			if(!extension && !extension2) {
				return this.$message({
					message: '上传文件只能是 xls、xlsx格式!',
					type: 'warning'
				});
			}
			if(!isLt5M) {
				return this.$message({
					message: '上传文件大小不能超过 5MB!',
					type: 'warning'
				});
			}

			 this.params.append('isArrangement',this.isArrangement);
			 this.params.append('isUse',this.isUse);
			 this.params.append('multipartFile',fileOne.raw);
			 this.params.append('cid',sessionStorage.getItem('cid'));
			 this.params.append('token',sessionStorage.getItem('token'));
			// console.log(this.params.get('multipartFile'))
			// console.log(this.params.get('isArrangement'))
			 try {
			 	const instance = this.$http.create({
			 		withCredentials: true
			 	})
			 	this.isImportFilesLoading = true;

			 	instance.post(this.$rootUrl + 'voucherChief/importFileVoucherChief', this.params).then(res=>{
			 		if(res && res.data.code == 1) {
			 			this.isImportFilesLoading = false;
			 			this.importFiles = false;
			 			this.$message.success(res.data.data.msg)
			 			this.fileList=[];
			 			this.$refs.upload.clearFiles();
			 			this.conutTimes = 1;
			 			this.getTableData(this.form);
			 		}else {
			 			this.isImportFilesLoading = false;
			 			this.fileList=[];
			 			this.$refs.upload.clearFiles();
			 			this.importFiles = false;
			 			this.conutTimes = 1;
			 			let data = res.data.data.list;
				     	//2.新建newDatas数组
				    	 let newDatas = [];
				     	 const h = this.$createElement;
				     	//3.通过循环data数组，调用h方法，将每项值传给h,h('标签名',样式,具体内容)
					    if(data.length) {
					    	data.forEach((i,index)=>{
					    		//4.将data数据push进newDatas数组中
					      		newDatas.push(h('p',{style: {color: 'red',fontSize: '14px'}},`${index+1}`+"、"+i));
					    	})
					    }
				        this.$msgbox({
				          title: '导入失败',

				          message: h('div',null, newDatas),
				          showCancelButton: false,
				          showClose: false,
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				        }).then(action => {
				         	return
				        });
			 		}
			 	})
			 }catch(e) {

			 }
		},
		// 导出
		handleDownload (){

			if(!this.ids&&this.exportFormData.exportScope==="2") {
				return this.$message.warning('请至少选择一条凭证！');
			}
			const params = {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
				ids: this.ids,
				exportScope:this.exportFormData.exportScope,
				exportType:this.exportFormData.exportType,
				startYearPeriods:this.form.startYearPeriods,
				endYearPeriods: this.form.endYearPeriods
			}
			const router =this.$router.resolve({
				path: '/export/voucherChiefExport',
				query: params
			})
			this.exportDialogShow = false;
			window.open(this.$rootUrl + router.href, '_blank');
		},
		// 打印功能块
		handlePrint() {

			if (!this.ids&&this.printFormData.exportScope==="2")  return this.$message.warning('请至少选择一条数据！');
			const params = {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
				ids: this.ids,
				exportScope:this.printFormData.exportScope,
				direction: this.printFormData.direction==="1"?"transverse":"",
				startYearPeriods:this.form.startYearPeriods,
				endYearPeriods: this.form.endYearPeriods,
				rotate: this.printFormData.rotate,
			}
			console.log(params,'打印参数')
			const router = this.$router.resolve({
				path: '/createPDF/printVoucherCheif',
				query: params
			})
			this.printDialogShow = false;
			window.open(this.$rootUrl + router.href, '_blank');
		},
		// 获取默认期间
		defaultDate(data) {
			this.yearPeriodsText = data;
		},
		// 从子组件获取凭证字
		getVoucherWord(data) {
			if(data.length) {
				this.VoucherWord = data;
				this.ZLPZ_form.fkVoucherWordId = data[0].id;
			}
		},
		// 审核~批量删除按钮操作
		handleButtonOperation(name) {
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.nowRowClickData.isPopoverShow = false;
			switch(name) {
				case '审核':
					this.handleExamine('audit','审核');
					break;
				case '反审核':
					this.handleExamine('backAudit','反审核');
					break;
				case '整理':
					this.ZL_voucherShow = true;
					this.ZLPZ_form.mode='1';
					break;
				case '批量删除':
					this.callBatchDel();
					break;
				default:
					this.$message.error('未知操作！')
			}
		},
		handlerMenus(name){
			switch(name) {
				case '审核':
					this.handleExamine('audit','审核','XG_Voucer_loading');
					break;
				case '反审核':
					this.handleExamine('backAudit','反审核','XG_Voucer_loading');
					break;
				case '复制':
					this.copyVoucher();
					break;
				case '删除凭证':
					this.deleteVouch();
					break;
				default:
					this.$message.error('未知操作！')
			}
		},
		// 审核 // 反审核
		handleExamine(key,val,loading) {
			const _=this;
			if(_.ids == ''){
				_.$message.error('请先选择一条数据!');
				return false;
			};
			_[loading] = true;
			_.$http.post('/voucherChief/auditStatus',{
				auditStatus:key,
				ids:_.ids
			}).then((res)=>{
				_[loading] = false;
				if(res && (res.data.code == '1')){
					_.$message.success(val+'成功!');
					_.getTableData(_.form);
				}
			}).catch(e=>{
				_[loading] = false;
			});
		},
		// 获取按钮权限
		getButton(arr,key){
			let params={
				permissions:arr.join(',')
			}
			try {
				this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
					if(res && res.data.code == 1) {
						if(res.data.data.length){
							this[key] = res.data.data;
						}
					}
				})
			}catch(e){
			}
		},
    handleConfirm(data) {
      if(data.tab == 1) {
        this.sendMessage_ZLPZ(data.form)
      }else {
        this._changeVoucherSequence(data.form);
      }
    },
    // 插入凭证
    async _changeVoucherSequence(form) {
      this.ZLPZ_loading = true;
      const { data } = await changeVoucherSequence(form);
      	this.ZLPZ_loading = false;
      if(data.code == 1) {
        this.ZL_voucherShow = false;
				this.getTableData(this.form);
        this.$message.success("操作成功！")
      }
    },
		// 整理凭证调用接口
		sendMessage_ZLPZ(form) {
			try {
				this.ZLPZ_loading = true;
				this.$http.post('voucherChief/arrangementVoucherCheif',form).then(res=>{
					this.ZLPZ_loading = false;
					if(res && res.data.code == 1) {
						this.ZL_voucherShow = false;
						this.getTableData(this.form);
					}
				})
			}catch(e) {
					this.ZLPZ_loading = false;
			}
		},
		// 接收会计期间数据
		defaultTime(data) {
			this.ZLPZ_form = Object.assign(this.ZLPZ_form,{
				yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM'),
			});
		},
		// 批量删除
		callBatchDel () {
			if (!this.ids)  return this.$message.error('请至少选择一条数据！');

			try {
			    this.$confirm(`确定要删除选中的数据吗？`, '提示', {
					type: 'warning',
					closeOnClickModal: false
				}).then(res=>{
					try {
						this.tableData.loading = true;
						this.$http.post('voucherChief/deleteds' , {ids: this.ids}).then(res=>{
							this.tableData.loading = false;
							if(res && res.data.code==1) {
								this.getTableData(this.form);
								this.$message.success('批量删除成功!');
							}
						})
					} catch (e) {
						this.tableData.loading = false;
					 }
				})
			} catch(e) {

			}
		},

		// 全选
		toggleRowSelection (val) {
			this.nowRowClickData.isPopoverShow = false;
			const _=this;
			let idsArr = val.filter(a=>{
				return a.rows;
			})
			const ids = idsArr.map(item => item.id);
			this.ids = ids.toString();
		},

		// 翻页
		handlePaginationChange (data) {
			const { pageNo, pageSize } = data;

			if (pageNo) {
				this.$set(this.form, 'currentPage', pageNo);
				this.$set(this.tableData.page, 'pageNo', pageNo);
			}

			if (pageSize) {
				this.$set(this.form, 'maxResult', pageSize);
				this.$set(this.tableData.page, 'pageSize', pageSize);
			}
			this.getTableData(this.form);
		},
		// 阻止默认点击事件
		returnFalse(){
			return false;
		},
		// 点击空白页消失
		clickBody() {
			this.boxHide = false;
		},
		// 获取子组件信息
		getFalseMessage(data) {
			this.boxHide = data;
		},

		// 接收子组件form信息过滤查询
		formMessage(data) {
      console.log(data)
			this.form = Object.assign(this.form,data)
			this.getTableData(this.form);
		},
		// 合并
		arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (columnIndex < 4 || columnIndex > 7) {
				if (row.rows) {
					return {
						rowspan: row.rows,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
		// 列表操作
		handleClickOperation(name , row) {
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.nowRowClickData.isPopoverShow = false;
			switch(name) {
				case '修改':
					this.handleModify(row);
					break;
				case '删除':
					this.deleteVoucher(row);
					break;
				case '插入' :
					this.handleInsert(row);
					break;
				default:
					this.$message.warning('暂无功能！');
					break;
			}
		},
		// 列表删除凭证操作
		deleteVoucher(row){
			if(row.isCheckOut == 1){
				this.$message.error('已结账不能删除！');
				return false;
			};
			try {
				 this.$confirm('此操作将删除该条凭证, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).then(() => {
			        	this.$http.post('voucherChief/deleted' , {id: row.id}).then(res=>{
							if(res&&res.data.code==1){
								this.$message({
						            type: 'success',
						            message: '删除成功!'
						          });
								this.XG_voucherShow = false;
								this.getTableData(this.form)
							}
						}).catch(e=>{

						});
			        });
			}catch(e) {

			}
		},
		// 列表修改操作
		handleModify(row){
			const _=this;
			this.nowRowClickData.isPopoverShow = false;

			_.XG_voucherShow = true;
			_.rows = row;
			_.openButton_s = true;
		},
		//凭证保存成功后的回调 ================================
		successAjax1(bol,key){
			const _=this;
			_[key] = false;
			_.$emit('on-success-submit',true);
			_.getTableData(this.form);
			if(key == 'CR_voucherShow'){
				_.$store.commit('UPDATAVOUCHER_SUPER',true);
			}
		},
		successEdit(val){//修改成功后的回调
			if(val){
				this.getTableData(this.form);
			}
		},
		// 列表插入操作
		handleInsert(row){
			const _=this;
			_.insert = row.selfNumber;
			_.CR_voucherShow = true;
		},//复制
		copyVoucher(){
			const _=this;
			let list = JSON.parse(JSON.stringify(_.Voucher_Chief_Data));
			if(list.voucherAddendumVoList.length >0){
				for(let i=0;i<list.voucherAddendumVoList.length;i++){
					delete list.voucherAddendumVoList[i].id;
				}
			};
			delete list.id;
			_.$setSessionStorage('copyVoucher',list);
			_.$router.push({
				path:'/addVoucher',
				query:{
					copy:'1',
				}
			});
		},
		deleteVouch(){
			let row = {
				id:this.ids,
			}
			this.deleteVoucher(row);
		},
		// 查询凭证
		getTableData(data) {
			this.tableData.loading = true;
			this.$http.post('voucherChief/find' , data).then(res=>{
				this.tableData.loading = false;
				if(res.data.code==1) {
					let datas = res.data.data.list;
					let arr = [] , num = 0 , id = datas.length&&datas[0].id;
					this.tableData.page.count = parseInt(res.data.data.total);
					this.tableData.data = res.data.data.list.map((item,index)=>{
						item.allSelect = false;
						item.signId = item.signId?item.signId.toString():"";
						item.signId_c = item.signId;
						item.signReason_c = item.signReason;
						item.isPopoverShow = false;
						// 格式化金额
						if(item.debit_money!=0 ){
							item.debit_money = currencys(item.debit_money);
						}
						if(item.creditor_money!=0 ){
							item.creditor_money = currencys(item.creditor_money);
						}
						// 借方金额贷方金额为0不显示
						for (let key in item) {
							if (key == 'debit_money' || key == 'creditor_money') {
								item[key] = item[key] || '';
							}
						}
						if(item.id == id) {
							arr.push(item);
						}else {
							arr = [],
							arr.push(item);
							num = index;
							id = datas[num].id;
						}
						datas[num].rows=arr.length;
						if(arr.length>1) {
							this.OrderIndexArr.push(arr);
						}
						return item;
					})
				}
			})
		},
		//  设置行hover效果
		tableRowClassName({row}) {
			 let array = this.hoverOrderArr
			for (var i = 0; i < array.length; i++) {
	          if (row.id == array[i].id) {
	            return 'success-row'
	          }
	        }
		},
		// 鼠标进入事件
		 cellMouseEnter(row, column, cell, event) {
		 	this.hoverOrderArr = [];
		 	this.OrderIndexArr.forEach(i=>{
		 		let arr = i.find(item=>{return item.id == row.id});
		 		if(this.hoverOrderArr.indexOf(arr)<0) {
		 			if(arr) {
		 				this.hoverOrderArr.push(arr);
		 			}
		 		}
		 	})
	      },
	    // 鼠标移出事件
	     cellMouseLeave: function (row, column, cell, event) {
	        this.hoverOrderArr = [];
	     },
		cancel(val,key){
			this.XG_voucherShow = val;
			this.openButton_s = false;
			if(key){

			}else{
				this.getTableData(this.form);
			}
		},
		goPath(url){
			const _=this;
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.$router.push(url);
		},
    // 回显打印设置
    async getPrintSetting(){
      try {
        const { data } = await findVoucherChiefPrintTemplate();
        const {printTemplate,exportScope,number,foreignCurrency,cover,manager, examine, cashier, creator,relatedBanks} = data.data
        const settingObj = {
          template: printTemplate || 1,
          exportScope : "2",
          unitPrice: !!number,
          currency: !!foreignCurrency,
          cover: !!cover,
          relatedBanks: !!relatedBanks,
          manager: !!manager,
          managerName: manager,
          audit: !!examine,
          auditName: examine,
          cashier: !!cashier,
          cashierName: cashier,
          tabulation: !!creator,
          tabulationName: creator
        }

        Object.assign(this.printFormData,settingObj)
      } catch (error) {
        console.log(error);
      }
    },
    // 确定打印
    printConfirm(){
      if (!this.ids &&　this.printFormData.exportScope==="2")  return this.$message.warning('请至少选择一条数据！');
      // 勾选了就必填
      if(this.managerError || this.auditError || this.cashierError || this.tabulationError) return false

      const {exportScope,template:printTemplate,unitPrice:number,currency:foreignCurrency,cover,relatedBanks,manager,managerName,audit,auditName,cashier,cashierName,tabulation,tabulationName} = this.printFormData

			const params = {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
				ids: exportScope === "2" ? this.ids : undefined,
				exportScope:this.printFormData.exportScope,
				startYearPeriods:this.form.startYearPeriods,
				endYearPeriods: this.form.endYearPeriods,
        printTemplate,
        number,
        foreignCurrency,
        cover,
        relatedBanks,
        manager: manager ? managerName : undefined,
        examine: audit ? auditName : undefined,
        cashier: cashier ? cashierName : undefined,
        creator: tabulation ? tabulationName : undefined,
		rotate: this.printFormData.rotate,
			}

      const path = '/createPDF/printVoucherCheif'

			const router = this.$router.resolve({
				path,
				query: params
			})
			this.printDialogShow = false;
			window.open(this.$rootUrl + router.href, '_blank');
    }
	},
	watch: {
		boxHide(val){
			val?document.body.addEventListener('click', this.clickBody):document.body.removeEventListener('click', this.clickBody)
		}
	},
	deactivated(){
		window.onkeydown =  null; ///移出绑定的事件
		this.XG_voucherShow = false;
		this.nowRowClickData.isPopoverShow = false;
		this.CR_voucherShow = false;
		//this.$destroy();
	}
}
</script>

<style lang="less">
	.queryVoucher_mark {
		.mark_item {
			margin-top: 20px;
		}
		.el-radio {
			margin-right: 10px;
		}

	}
    .printDialog_s {
    	.el-dialog__header {
    		border-bottom: 1px solid #eee;
    	}
    	.printTitle {
    		font-weight: bold;
    		color: #666;
    	}
    }
	#queryVoucher{
	.list_btns {
		display: flex;
		align-items: center;
	}
    height: calc(100% - 20px);
    box-sizing: border-box;
		.s_container {
			transform: translateY(5px);
		}
		.DR_dialog {
			.el-dialog {
				.el-dialog__header {
					padding: 17px 20px;
					border-bottom: 1px solid #E5E5E5;
					.el-dialog__title {
						color: #333;
						font-size: 14px;
						font-weight: 600;
					}

				}
				.el-dialog__body {
					    padding: 18px 20px;
				}
			}
		}
		.click_container {
			width: 100%;
			height: 100%;
			padding:0;
      line-height: 27px;
			position: relative;
		}
		.el-table th div {
			vertical-align: middle;
		}
		.searchBox{
			position: absolute;
			z-index: 2
		}
		.dialog-footer {
			text-align: right;
		}
		.fliesUplaod{
			.fliesUplaod_text {
				color: #EC681D;
				display: inline-block;
				margin-bottom: 20px;
			}
			.handleDownload {
				margin: 3px 0 18px 0;
			}
			.uploads{
				padding:15px 0px;
				.el-upload-dragger {
					width: 250px;
					height: 90px;
					.el-icon-upload {
						font-size: 35px;
						margin: 0;
						line-height: 45px;
					}
				}
			}
		}
		.Voucher_OverFLow{
			position: relative;
			.disableModal{
				position: absolute;z-index: 1;
				width: 100%;
				height: 100%;
				left: 0;top:0;right: 0;
			}
		}

    // 打印弹框
    .printDialog{
      .el-dialog__title{
        font-size: 24px;
        font-weight: 500;
      }
      .print_area{
        margin-top: 30px;

        &:first-child{
          margin-top: 0;
        }
      }

      .print_area_title{
        font-size: 14px;
        font-weight: 600;
        color: #4a4a4a;
        margin-bottom: 20px;
      }

      // 打印模板
      .print_area_template{
        width: 100%;
        height: 227px;
        opacity: 0.7;
        background: #F6F8FA;
        padding: 20px 30px;
        box-sizing: border-box;
        display: flex;

        .print_area_template_A4{
          width: 80%;
          margin-right: 30px;

          .print_area_template_A4_title{
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .print_area_template_A4_contents{
            display: flex;
            justify-content: space-between;

            .print_area_template_A4_content{
              background-color: #fff;
              border-radius: 4px;
              width: 100px;
              height: 130px;
              padding: 6px;
              box-sizing: border-box;
              position: relative;
              border: 1px solid transparent;
              cursor: pointer;

              .print_template_item{
                padding: 3px 4px;
                background: #f4fcf9;
                border-radius: 2px;
                // color: #269D7B;
                color: rgba(38,157,123,.4);;
                font-size: 10px;
                font-weight: 600;
              }

              .item_1{
                height: calc(100% - 8px);
              }

              .item_2{
                height: calc((100% - 16px) / 2);
                margin-bottom: 4px;
              }

              .item_3{
                height: calc((100% - 24px) / 3);
                margin-bottom: 4px;
              }

              .print_template_footer{
                position: absolute;
                bottom: -30px;
                left: 0;
                font-weight: 400;
                font-size: 12px;
                letter-spacing: 0;
                color: #999;
              }
            }

            .active{
              box-shadow: 0 4px 6px 0 #269d7b4d;
              border: 1px solid #269D7B;
              position: relative;

              .print_template_footer{
                color: #269D7B;
              }

              &::after{
                content:" ";
                width: 20px;
                height: 20px;
                background: url('../../../static/img/correct_active.png') no-repeat;
                background-size: 20px 20px;
                position: absolute;
                right: -1px;
                top: -1px;
              }
            }
          }
        }

        .print_area_template_A5{
          width: 20%;

          .print_area_template_A5_title{
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .print_area_template_A5_contents{
            display: flex;
            justify-content: space-between;

            .print_area_template_A5_content{
              background-color: #fff;
              border-radius: 4px;
              width: 90px;
              height: 100px;
              padding: 6px;
              box-sizing: border-box;
              position: relative;
              border: 1px solid transparent;
              cursor: pointer;

              .print_template_item{
                padding: 3px 4px;
                background: #f4fcf9;
                border-radius: 2px;
                // color: #269D7B;
                color: rgba(38,157,123,.4);;
                font-size: 10px;
                font-weight: 600;
              }

              .item_1{
                height: calc(100% - 8px);
              }

              .print_template_footer{
                position: absolute;
                bottom: -60px;
                left: 0;
                font-weight: 400;
                font-size: 12px;
                letter-spacing: 0;
                color: #999;
              }
            }

            .active{
              box-shadow: 0 4px 6px 0 #269d7b4d;
              border: 1px solid #269D7B;
              position: relative;

              .print_template_footer{
                color: #269D7B;
              }

              &::after{
                content:" ";
                width: 20px;
                height: 20px;
                background: url('../../../static/img/correct_active.png') no-repeat;
                background-size: 20px 20px;
                position: absolute;
                right: -1px;
                top: -1px;
              }
            }
          }
        }
      }

      // 打印范围
      .print_area_scope{
        .el-radio__input.is-checked+.el-radio__label{
          color: #666;
        }

        .el-radio__input.is-checked .el-radio__inner {
          border-color: #269D7B;
          background: #fff;
        }

        .el-radio__inner::after{
          background-color: #269D7B;
        }

      }

      // 打印内容
      .print_area_quality{
        display: flex;

        .print_area_left{
          display: flex;
          flex-direction: column;

          .el-checkbox{
            margin-bottom: 20px;
          }

          .absolute_img{
            position: absolute;
            top: 2px;
            left: 60px;
            width: 16px;
            cursor: pointer;
          }
        }

        .print_area_right{
          .print_area_right_item{
            position: relative;
            display: flex;

            .el-checkbox{
              margin-bottom: 20px;
            }

            .el-input{
              margin-left: 10px;
              transform: translateY(-3px);
            }

            .error_input{
              .el-input__inner{
                border-color: #F56C6C;
              }
            }

            .error_msg{
              position: absolute;
              bottom: 0;
              left: 62px;
              font-size: 12px;
              color: red;
            }
          }
        }
      }

      // 打印按钮组
      .print_area_btns{
        .el-button--primary{
          border-color: #269D7B;
          background-color:#269D7B;
        }

        .el-button--default:hover{
          color: #269D7B;
          border-color:#269D7B;
        }
      }
    }

    // 凭证封面弹窗
    .coverDialog{
      img{
        width: 100%;
      }
    }
	}

</style>



// WEBPACK FOOTER //
// src/pages/voucher/queryVoucher.vue